import $ from "jquery";
$.ajaxSetup({
  beforeSend: function(xhr) {
    xhr.setRequestHeader("X-Okta-XsrfToken", $("#_xsrfToken").text());
  },
  converters: {
    "text secureJSON": function(str) {
      if (str.substring(0, 11) === "while(1){};") {
        str = str.substring(11);
      }
      return JSON.parse(str);
    }
  }
});
const oktaJQueryStatic = $;
window.jQueryCourage = oktaJQueryStatic;
export { oktaJQueryStatic as default };
